
















import Vue from 'vue'
import Init from './components/Init.vue'

export default Vue.extend({
	name: 'App',
	components: {
		Init
	}
})
